const custom = resolve => require(['@/components/custom/qykf/index.vue'], resolve);
// import home from '/components/workbench/workbench.vue'
export default [{
    path: '/homeMain/custom/qykf',
    component: custom,
}]


// WEBPACK FOOTER //
// ./src/router/custom.js